import { NgModule } from '@angular/core';
import { AuthGuard } from './_guards/auth.guard';
import { PreloadAllModules, RouterModule, Routes } from '@angular/router';
import { LoginGuard } from './_guards/login.guard';

const routes: Routes = [
  { path: '', redirectTo: 'login', pathMatch: 'full' },
  {
    path: 'login',
    canActivate: [LoginGuard],
    loadChildren: () =>
      import('./public/login/login.module').then((m) => m.LoginPageModule),
  },
  {
    path: 'tenants',
    canActivate: [AuthGuard],
    children: [
      {
        path: '',
        loadChildren: () =>
          import('./private/tenants/tenants.module').then(
            (m) => m.TenantsPageModule
          ),
      },
    ],
  },
  {
    path: '',
    canActivate: [AuthGuard],
    loadChildren: () =>
      import('./private/terminal/terminal.module').then(
        (m) => m.TerminalPageModule
      ),
  },
];

@NgModule({
  imports: [
    RouterModule.forRoot(routes, { preloadingStrategy: PreloadAllModules }),
  ],
  exports: [RouterModule],
})
export class AppRoutingModule {}
